<template>
  <!-- width="95" height="95" -->
  <circle cx='47.5001' cy='47.5' r='47.5' fill='#F1F5F9' />
  <circle cx='48.3963' cy='34.0564' r='13.3396' stroke='#1C498E' stroke-width='2' />
  <path
    d='M28.6793 69.9059V67.2172C28.6793 56.8228 37.1057 48.3965 47.5001 48.3965V48.3965C57.8945 48.3965 66.3208 56.8228 66.3208 67.2172V69.9059'
    stroke='#1C498E' stroke-width='2' stroke-linecap='round' />
</template>
